export const locales = {
	loadMore: 'Voir toute la liste'
};
